/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    pre: "pre",
    a: "a",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Why am I getting HTML attribute warnings?"
    }), "\n", _jsxs(_components.p, {
      children: ["The warning message below indicates that non-standard attributes are being attached to\nHTML DOM elements such as ", _jsx(_components.code, {
        children: "<div>"
      }), " or ", _jsx(_components.code, {
        children: "<a>"
      }), ". If you are seeing this warning message, it is likely that you or a library you are using is attaching props as attributes to HTML DOM elements."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        children: "Warning: Received \"true\" for a non-boolean attribute\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If you're seeing this warning you are probably passing ", _jsx(_components.code, {
        children: "true"
      }), " where ", _jsx(_components.code, {
        children: "\"true\""
      }), " would be appropriate. It's likely that this comes from a ", _jsx(_components.code, {
        children: ".attrs"
      }), " property, or from a completely unrelated prop that you're passing to a ", _jsx(_components.code, {
        children: "styled(Component)"
      }), " component."]
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more about how props are passed, see ", _jsx(_components.a, {
        href: "/docs/basics#passed-props",
        title: "Passing Props to styled-components",
        children: "this section"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "For example:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Link = props => (\n  <a {...props} className={props.className}>\n    {props.text}\n  </a>\n)\n\nconst StyledComp = styled(Link)`\n  color: ${props => (props.red ? 'red' : 'blue')};\n`\n\n<StyledComp text=\"Click\" href=\"https://www.styled-components.com/\" red />\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "This will render:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-html",
        children: "<a text=\"Click\" href=\"https://www.styled-components.com/\" red=\"true\" class=\"[generated class]\">Click</a>\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["React will warn on non-standard attributes being attached such as \"red\" and \"text\", which are not valid HTML attributes for the ", _jsx(_components.code, {
        children: "<a>"
      }), " element."]
    }), "\n", _jsx(_components.p, {
      children: "To fix this, you can use transient props or destructure props:"
    }), "\n", _jsx(_components.h3, {
      children: "transient props (since 5.1)"
    }), "\n", _jsxs(_components.p, {
      children: ["You can use ", _jsx(_components.a, {
        href: "https://styled-components.com/docs/api#transient-props",
        children: "transient props"
      }), " to fix this:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Link = ({ className, text, ...props }) => (\n  <a {...props} className={className}>\n    {text}\n  </a>\n)\n\nconst StyledComp = styled(Link)`\n  color: ${props => (props.$red ? 'red' : 'blue')};\n`\n\n<StyledComp text=\"Click\" href=\"https://www.styled-components.com/\" $red />\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "destructure props"
    }), "\n", _jsx(_components.p, {
      children: "If you use a version < 5.1 or if you can't use transient props, you can use argument destructuring to pull out those known styling props:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const Link = ({ className, red, text, ...props }) => (\n  <a {...props} className={className}>\n    {text}\n  </a>\n)\n\nconst StyledComp = styled(Link)`\n  color: ${props => (props.red ? 'red' : 'blue')};\n`\n\n<StyledComp text=\"Click\" href=\"https://www.styled-components.com/\" red />\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "This will render:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-html",
        children: "<a href=\"https://www.styled-components.com/\" class=\"[generated class]\">Click</a>\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["When you use argument destructuring, any variables pulled out of the props object will not be included when spread-applying the remaining props (", _jsx(_components.code, {
        children: "...props"
      }), ");"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
